import React from "react";
import UserLayout from "../layout/UserLayout";
import HeroSection from "../components/HeroSection";
import HomeShowcase from "../components/HomeShowcase";
import WhyChooseUs from "../components/WhyChooseUs";
import ContactSection from "../components/ContactSection";
import PageBreak from "../components/PageBreak";

const Home = () => {
  return (
    <UserLayout>
      {/* 1. Hero Showcase Banner */}
      <HeroSection />

      {/* 2. Four Core Export Pillars: Tea, Coconut, Spices, Traditional Rice */}
      <HomeShowcase />

      <PageBreak />

      {/* 3. Why Choose Ceymos: Quality, Ethics, Global Standards */}
      <WhyChooseUs />

      <PageBreak />

      {/* 4. Global Contact & Export Inquiries */}
      <ContactSection />
    </UserLayout>
  );
};

export default Home;
